<template>
  <div id="language" class="language-content">
    <v-nav/>
    <page-title :brain-type="$t('standardBrain')" :menu-name="$t('languageFunctionMapping')" style="z-index: 2;position:absolute;top: 50px;left: 10px"/>
    <div id="brainFace" style="width: 80%;margin-left: 20%;z-index: 1" :style="{height : contentHeight}"></div>
    <div class="positionContent" v-if="currentPoint != null"
         :style="{top : labelTop +'px', left : labelLeft + 'px'}">
      <a-tag color="purple" style="font-size: 16px">{{ currentPoint.px }}，{{ currentPoint.py }}，{{
          currentPoint.pz
        }}
      </a-tag>
    </div>
    <div class="condition-content" style="z-index: 2">
      <div class="option-panel">
        <a-checkbox-group v-model:value="languageId">
          <a-row>
            <a-col v-for="item in optionList" :key="item.value" :span="24">
              <a-checkbox :value="item.value">
                <div style="display: inline-block;height: 10px;width: 10px" :style="{backgroundColor: 'rgb('+ (item.color[0] * 255) +',' + (item.color[1]*255) + ',' + (item.color[2]*255) + ')'}"></div>
                {{ item.label }}
              </a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </div>
      <div class="option-panel" style="margin-top: 12px">
        <div style="width: 100%;text-align: center">
          <a-button ghost style="color: white" @click="download">{{ $t("dataDownload") }}</a-button>
        </div>
      </div>
    </div>
    <v-loading :show="loading"></v-loading>
  </div>
</template>

<script>
import VNav from "@/components/public/VNav";
import PageTitle from "@/components/public/pageTitle";
import vtkPointPicker from "@kitware/vtk.js/Rendering/Core/PointPicker";
import vtkRenderWindowWithControlBar from "@kitware/vtk.js/Rendering/Misc/RenderWindowWithControlBar";
import util from "@/util/util";
import vtkOBJReader from "@kitware/vtk.js/IO/Misc/OBJReader";
import vtkMapper from "@kitware/vtk.js/Rendering/Core/Mapper";
import vtkActor from "@kitware/vtk.js/Rendering/Core/Actor";
import vtkSphereSource from "@kitware/vtk.js/Filters/Sources/SphereSource";
import VLoading from "@/components/public/v-loading";
import { Modal } from "ant-design-vue";

export default {
  name: "languageFunctionMap",
  components: {VLoading, PageTitle, VNav},
  data() {
    return {
      languageId: [],
      contentHeight: 0,
      pointPicker: {},
      brainRenderWindow: {},
      brainRenderer: {},
      pointActorList: [],
      pointList: [],
      currentPointActor: null,
      loading: false,
      labelTop: 50,
      labelLeft: 50,
    }
  },
  beforeMount() {
    this.computedHeight();
  },
  mounted() {
    this.initPage();
  },
  methods: {
    download() {
      // if (util.isNull(this.languageId)) {
      //   util.error("请选择语言功能！");
      //   return;
      // }
      // var text = "";
      // this.pointList.map(item => {
      //   text += item.px + "," + item.py + "," + item.pz + "\n";
      // })
      // var filter = this.optionList.filter(item => this.languageId.includes(item.value));
      // var name = []
      // filter.map(item => {
      //   name.push(item.label)
      // })
      // util.download_txt(name.join("-") + ".txt", text);
      // util.$post("/home/visitAddress", {type : "01"});
      Modal.info({
        title: this.$t('downloadTip', { email: 'baohongbo1990@hotmail.com' }),
      })
    },
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
    initPage() {
      // 初始化小球picker
      this.pointPicker = vtkPointPicker.newInstance();
      this.pointPicker.setPickFromList(1);
      this.pointPicker.initializePickList();
      this.pointPicker.setTolerance(0.005)
      this.drawBrain();
    },
    drawBrain() {
      const fullScreenRenderer = vtkRenderWindowWithControlBar.newInstance();
      fullScreenRenderer.setControlSize(0)
      fullScreenRenderer.setBackground([0.2627451, 0.20392157, 0.32156863]);
      fullScreenRenderer.setContainer(document.getElementById("brainFace"))
      this.brainRenderer = fullScreenRenderer.getRenderer();
      this.brainRenderWindow = fullScreenRenderer.getRenderWindow();
      // this.readObjMode(util.baseUrl + "BrainMesh_Ch2.obj", this.brainRenderer, this.brainRenderWindow);
      this.readObjMode(util.baseUrl + "surface_2f.obj", this.brainRenderer, this.brainRenderWindow);
    },
    readObjMode(url, renderer, renderWindow) {
      const reader = vtkOBJReader.newInstance();
      reader.setUrl(url).then(() => {
        const size = reader.getNumberOfOutputPorts();
        for (let i = 0; i < size; i++) {
          const polydata = reader.getOutputData(i);
          const mapper = vtkMapper.newInstance();
          const actor = vtkActor.newInstance();
          actor.setMapper(mapper);
          actor.getProperty().setOpacity(0.2)
          mapper.setInputData(polydata);
          renderer.addActor(actor);
        }
        renderer.resetCamera();
        renderWindow.render();
      });
    },
    computedHeight() {
      this.contentHeight = (window.innerHeight - 48) + "px";
    },
    initBrainPoint() {
      if (util.isNull(this.languageId)) {
        return;
      }
      var post = {
        bodyId: JSON.stringify(this.languageId)
      }
      util.$post("/home/getLanguageList", post, (res) => {
        this.pointList = res.pointList;
        this.drawBrainPoints();
      }, this.showMask, this.hideMask);
    },
    drawBrainPoints() {
      this.pointPicker.initializePickList();
      // vtkUtil.removePickerList(this.pointPicker, this.pointActorList);
      this.pointList.map(item => {
        var originalColor = this.colorMap[item.pointtype];
        const sphere = vtkSphereSource.newInstance();
        sphere.setCenter(item.px, item.py, item.pz);
        sphere.setRadius(0.5);
        const sphereMapper = vtkMapper.newInstance();
        sphereMapper.setInputData(sphere.getOutputData());
        const sphereActor = vtkActor.newInstance();
        sphereActor.setMapper(sphereMapper);
        sphereActor.getProperty().setColor(originalColor);
        sphereActor.getProperty().set({cibrPoint: item, sphere: sphere, originalColor: originalColor}, true, true)
        this.pointPicker.addPickList(sphereActor);
        this.pointActorList.push(sphereActor);
        this.brainRenderer.addActor(sphereActor);
      });
      this.brainRenderWindow.render();
      this.initPointPickerEvent();
    },
    initPointPickerEvent() {
      this.currentPointActor = null;
      this.brainRenderWindow.getInteractor().onLeftButtonPress((callData) => {
        if (this.brainRenderer !== callData.pokedRenderer) {
          return;
        }
        const pos = callData.position;
        const point = [pos.x, pos.y, 0.0];
        console.log(pos)
        var brainContainer = document.getElementById("brainFace");
        console.log(brainContainer.getBoundingClientRect())
        this.labelTop = brainContainer.getBoundingClientRect().bottom - pos.y * 0.7;
        this.labelLeft = brainContainer.getBoundingClientRect().left + pos.x * 0.7;

        this.pointPicker.pick(point, this.brainRenderer);
        if (this.pointPicker.getActors().length > 0) {
          var actor = this.pointPicker.getActors()[0];
          this.currentPointActor = actor;
        } else {
          this.currentPointActor = null;
        }
      })
    },
    removeBrainAllPointAndLine() {
      this.pointActorList.map(item => {
        this.brainRenderer.removeActor(item);
      })
      this.pointActorList = [];
      this.brainRenderWindow.render();
    },
  },
  watch: {
    languageId() {
      this.removeBrainAllPointAndLine();
      this.initBrainPoint();
    },
    currentPointActor(newVal, oldVal) {
      if (!util.isNull(oldVal)) {
        var color = oldVal.getProperty().get().originalColor;
        oldVal.getProperty().setColor(color);
      }
      if (!util.isNull(newVal)) {
        newVal.getProperty().setColor([0, 1, 0]);
      }
      this.brainRenderWindow.render();
    },
  },
  computed: {
    currentPoint() {
      if (util.isNull(this.currentPointActor)) {
        return null
      }
      return this.currentPointActor.getProperty().get().cibrPoint;
    },
    colorMap(){
      var colorMap = {};
      this.optionList.map(item => colorMap[item.value] = item.color);
      return colorMap;
    },
    optionList() {
      var list = new Array();
      list.push({color: [1, 0.160784, 0.023529],label: this.$t("anepia"), value: "anepia"});
      list.push({color: [0.835294, 0, 1], label: this.$t("cannotName"), value: "anomia"});
      list.push({color: [1, 0.333333, 0.007843],label: this.$t("aphonia"), value: "aphonia"});
      list.push({color: [1, 0.501960, 0.003921],label: this.$t("asophia"), value: "asophia"});
      list.push({color: [1, 0.666667, 0.003921],label: this.$t("bradyphrasia"), value: "bradyphrasia"});
      list.push({color: [0.007843, 0.501960, 1],label: this.$t("error"), value: "error"});
      list.push({color: [0.498039, 0.003921, 1],label: this.$t("speechBreak"), value: "speechArrest"});
      // list.push({color: [0.007843, 1, 0],label: this.$t("mispronunciation"), value: "mispronunciation"});
      // list.push({color: [1, 0, 0.835294],label: this.$t("nameError"), value: "nameError"});
      list.push({color: [0.003921, 0.835294, 1],label: this.$t("speechRepetition"), value: "repeat"});
      list.push({color: [0.003921, 0.666667, 1],label: this.$t("chineseOnly"), value: "onlyChinese"});
      list.push({color: [0.501960, 1, 0],label: this.$t("englishOnly"), value: "onlyEnglish"});
      list.push({color: [0.333333, 1, 0],label: this.$t("germanOnly"), value: "germanOnly"});
      list.push({color: [0.172549, 1, 0],label:  this.$t("japaneseOnly"), value: "japaneseOnly"});
      list.push({color: [0, 1, 0.149019],label: this.$t("conversionBilingual"), value: "conversionBilingual"});
      return list;
    }
  }
}
</script>

<style scoped>
.language-content {
  width: 100%;
  height: 100vh;
  overflow: auto;
  background-color: #433452;
}

.condition-content {
  width: 200px;
  /*background-color: #5A2781;*/
  /*border-radius: 20px;*/
  /*border: 1px #552D6D solid;*/
  /*padding: 16px 16px;*/
  position: absolute;
  top: 180px;
  left: 20px;
}

.positionContent {
  position: fixed;
  top: 180px;
  left: 250px;
  z-index: 9;
  color: white;
  font-size: 24px;
}
</style>